import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import DeleteModal from '../../../../components/DeleteModal'
import clsx from 'clsx'

import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    justifyContent: 'left',
    paddingLeft: 0,
  },
  disabled: {
    color: theme.palette.grey[400],
    cursor: 'auto',
  },
}))

const DeleteAllOligos = ({
  handleDeleteAll,
  disabled,
  oligoCount,
}: {
  disabled: boolean
  handleDeleteAll: () => void
  oligoCount: number
}) => {
  const classes = useStyles()
  const [dialogOpen, setDialogOpen] = useState(false)
  const handleClose = () => {
    setDialogOpen(false)
  }

  const triggerDeleteAll = () => {
    setDialogOpen(true)
  }
  const dleteAllOligos = () => {
    handleDeleteAll()
    setDialogOpen(false)
  }

  return (
    <>
      <Button
        onClick={triggerDeleteAll}
        disabled={disabled}
        className={clsx(classes.button, disabled && classes.disabled)}
      >
        <FormattedMessage
          id="CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES"
          defaultMessage="Delete All"
        />
        <span>&nbsp;{`(${oligoCount})`}</span>
      </Button>
      <DeleteModal
        dialogOpen={dialogOpen}
        handleClose={handleClose}
        handleDelete={dleteAllOligos}
        deleteType="All"
      />
    </>
  )
}

export default DeleteAllOligos
